export default "/images/marker-rent.svg?03f1a88a45f78ec39db64379980a0f4c";